import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import LogoImage from "./img/tech.png"; // <-- Import your local logo image

const Footer = ({ sections }) => {
  // Smooth scroll function
  const scrollToSection = (section) => {
    if (sections[section]?.current) {
      sections[section].current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer
      style={{
        background: "linear-gradient(to right, #948b8bff, #a66b50ff)",
        color: "#fff",
        padding: "3rem 2rem",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          maxWidth: "1200px",
          margin: "0 auto",
          gap: "2rem",
        }}
      >
        {/* Company Info */}
        <div style={{ flex: "1 1 250px" }}>
          <img
            src={LogoImage}
            alt="Logo"
            style={{
              height: "50px",
              width: "auto",
              marginBottom: "1rem",
              cursor: "pointer",
            }}
            onClick={() => scrollToSection("home")}
          />
          <p>
            Building modern, responsive websites and web apps that empower your business.
          </p>
        </div>

        {/* Quick Links */}
        <div style={{ flex: "1 1 150px" }}>
          <h4 style={{ fontWeight: "bold", marginBottom: "1rem" }}>Quick Links</h4>
          <ul style={{ listStyle: "none", padding: 0 }}>
            <li
              style={{ marginBottom: "0.5rem", cursor: "pointer" }}
              onClick={() => scrollToSection("home")}
            >
              Home
            </li>
            <li
              style={{ marginBottom: "0.5rem", cursor: "pointer" }}
              onClick={() => scrollToSection("services")}
            >
              Services
            </li>
            <li
              style={{ marginBottom: "0.5rem", cursor: "pointer" }}
              onClick={() => scrollToSection("pricing")}
            >
              Pricing
            </li>
            <li
              style={{ marginBottom: "0.5rem", cursor: "pointer" }}
              onClick={() => scrollToSection("contact")}
            >
              Contact
            </li>
          </ul>
        </div>

        {/* Social Media */}
        <div style={{ flex: "1 1 150px" }}>
          <h4 style={{ fontWeight: "bold", marginBottom: "1rem" }}>Follow Us</h4>
          <div style={{ display: "flex", gap: "0.75rem" }}>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#2d1ad3ff", fontSize: "1.2rem" }}
            >
              <FaFacebookF />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1a7ca9ff", fontSize: "1.2rem" }}
            >
              <FaTwitter />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#170663ff", fontSize: "1.2rem" }}
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#7e0808ff", fontSize: "1.2rem" }}
            >
              <FaInstagram />
            </a>
          </div>
        </div>

        {/* Newsletter Subscription */}
        <div style={{ flex: "1 1 250px" }}>
          <h4 style={{ fontWeight: "bold", marginBottom: "1rem" }}>Newsletter</h4>
          <p style={{ marginBottom: "0.5rem" }}>Subscribe to get the latest updates:</p>
          <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap" }}>
            <input
              type="email"
              placeholder="Enter your email"
              style={{
                padding: "0.5rem 1rem",
                borderRadius: "5px",
                border: "none",
                flex: "1 1 auto",
              }}
            />
            <button
              style={{
                padding: "0.5rem 1rem",
                borderRadius: "5px",
                border: "none",
                backgroundColor: "#fd0404ff",
                color: "#ffffffff",
                fontWeight: "bold",
                cursor: "pointer",
                flex: "0 0 auto",
              }}
            >
              Subscribe
            </button>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div
        style={{
          textAlign: "center",
          marginTop: "2rem",
          borderTop: "1px solid rgba(255,255,255,0.3)",
          paddingTop: "1rem",
          fontSize: "0.9rem",
        }}
      >
        &copy; {new Date().getFullYear()} Woolley_Tech. All rights reserved.
        <div style={{ marginTop: "0.5rem", display: "flex", gap: "1.5rem", justifyContent: "center", flexWrap: "wrap" }}>
          <Link to="/terms" style={{ color: "#fff", textDecoration: "none", cursor: "pointer" }}>
            Terms and Conditions
          </Link>
          <Link to="/privacy" style={{ color: "#fff", textDecoration: "none", cursor: "pointer" }}>
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
